module.exports = __webpack_public_path__ + "img/Tiktok.801caac9.svg";